export default {
  nodeKey: 'id',
  addBtn: false,
  editBtn: false,
  menu: false,
  size: 'small',
  props: {
    label: 'title',
    children: 'children',
  },
};
